module.exports = __webpack_public_path__ + "cert-restrictto.27c8439f9341baef8f7eafdf7901bca1.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/layout/cert-restrictto.png
// module id = 1391996480217646
// module chunks = 1